import React from 'react';
import Header1 from '../typographies/header1';

export default class ProblemList extends React.Component {
  renderProblems() {
    return this.props.problems.map(item => {
      return (
        <li className="item" key={item.id}>
          <Problem
            title={item.title}
          />
        </li>
      );
    });
  }
  render() {
    return (
      <div className="box shadow superpadded">
        <div className="box-title">
          <Header1
              key="header"
              className="text-center"
              text="Problem(s) we are currently working on"
          />
        </div>
        <div className="box-body">
          <ul className={`list margin-t-60 nav flex-column ${this.props.className ? this.props.className : ''}`}>
            {
              this.renderProblems()
            }
          </ul>
        </div>
      </div>
    );
  }
}

const Problem = (props) => (
  <div className="row justify-content-left align-items-center">
    <div className="activity-circle pulse red glow">
    </div>
    <p className="text para-1 grey light col-11 margin-0">
      {props.title}
    </p>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/list/problemList.js